import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './nest-rules.module.scss';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export interface NestRulesDetailsProps {
  data: {
    cancelationPolicy: string | undefined;
    guestRegulations: string | undefined;
    houseRules: string | undefined;
    cancelationPolicyAr?: string | undefined;
    guestRegulationsAr?: string | undefined;
    houseRulesAr?: string | undefined;
  };
  eventHandlers: {
    uploadNestRules: (nestRules: {
      cancelationPolicy: string;
      guestRegulations: string;
      houseRules: string;
      cancelationPolicyAr?: string;
      guestRegulationsAr?: string;
      houseRulesAr?: string;
    }) => void;
  };
}

const NestRulesDetails: React.FC<NestRulesDetailsProps> = ({ data, eventHandlers }) => {
  const { t } = useTranslation();
  const isMobileView = useWindowResizer();

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isNestRulesExpanded, setIsNestRulesExpanded] = useState<boolean>(true);
  const [nestRules, setNestRules] = useState({
    cancelationPolicy: '',
    guestRegulations: '',
    houseRules: '',
    cancelationPolicyAr: '',
    guestRegulationsAr: '',
    houseRulesAr: ''
  });

  useEffect(() => {
    if (data) {
      setNestRules({
        cancelationPolicy: data?.cancelationPolicy || '',
        guestRegulations: data?.guestRegulations || '',
        houseRules: data?.houseRules || '',
        cancelationPolicyAr: data?.cancelationPolicyAr || '',
        guestRegulationsAr: data?.guestRegulationsAr || '',
        houseRulesAr: data?.houseRulesAr || ''
      });
    }
  }, [data]);

  const handleSubmit = () => {
    eventHandlers.uploadNestRules(nestRules);
  };

  const nestRuleSections = [
    {
      title: 'House Rules',
      name: 'houseRules',
      nameAr: 'houseRulesAr',
      index: 0
    },
    {
      title: 'Guest Regulations',
      name: 'guestRegulations',
      nameAr: 'guestRegulationsAr',
      index: 1
    },
    {
      title: 'Cancelation Policy',
      name: 'cancelationPolicy',
      nameAr: 'cancelationPolicyAr',
      index: 2
    }
  ];

  const currentSection = nestRuleSections[activeIndex];
  const inputName = currentSection.name as keyof typeof nestRules;
  const inputNameAr = currentSection.nameAr as keyof typeof nestRules;

  return (
    <>
      <div
        onClick={() => setIsNestRulesExpanded(!isNestRulesExpanded)}
        className={`${styles['compound-details-container__expand-header']} ${
          isNestRulesExpanded
            ? styles['compound-details-container__expand-header--expanded']
            : styles['compound-details-container__expand-header--collapsed']
        }`}
      >
        <h3 className={styles['nest-rules-title']}>
          {t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.NEST_RULES')}
        </h3>
        <span className={styles['expand-arrow']}>▼</span>
      </div>

      {isNestRulesExpanded && (
        <div className={styles['compound-details-container']}>
          <div className={styles['compound-details-container__expand-content']}>
            <div className={styles['compound-details-container__tabs']}>
              {nestRuleSections.map((item, index) => (
                <button
                  type="button"
                  key={index}
                  className={`${styles['compound-details-container__tab']} ${
                    activeIndex === index ? styles.active : ''
                  }`}
                  onClick={() => setActiveIndex(index)}
                >
                  {item?.title}
                </button>
              ))}
            </div>

            <div className={styles['compound-details-container__content']}>
              <div className={styles['compound-details-container__field']}>
                <label className={styles['compound-details-container__label']}>
                  {t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.COMPOUND_DESCRIPTION')}
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  key={`${inputName}-en`}
                  data={nestRules[inputName] || ''}
                  onChange={(_event: any, editor: any) => {
                    const newData: string = editor.getData();
                    setNestRules((prev) => ({
                      ...prev,
                      [inputName]: newData
                    }));
                  }}
                />
              </div>

              <label className={styles['compound-details-container__label']}>
                الوصف بالعربي (Arabic Description)
              </label>
              <CKEditor
                editor={ClassicEditor}
                key={`${inputNameAr}-ar`}
                data={nestRules[inputNameAr] || ''}
                config={{ language: 'ar' }}
                onChange={(_event: any, editor: any) => {
                  const newData: string = editor.getData();
                  setNestRules((prev) => ({
                    ...prev,
                    [inputNameAr]: newData
                  }));
                }}
              />
            </div>
            <div className={styles['compound-details-container__actions']}>
              <Button
                onClick={handleSubmit}
                tracking={{
                  event: 'record_saved',
                  entity: 'compound',
                  action: 'update',
                  outcome: 'success'
                }}
                // disabled={!descriptionInputs[activeIndex]?.isValid}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              >
                {t('PROPERTY_MODULE.EDIT_GENERAL_CONTAINER.UPDATE_NEST_RULES')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NestRulesDetails;
